var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormWrapper',{attrs:{"form":_vm.form,"hideForm":_vm.hideForm,"handleOpened":() => _vm.handleProps({ key: 'opened', value: !_vm.form.opened })}},[_c('div',{staticClass:"form-group mb-0 break-spaces"},[_c('ScreeningResume',{attrs:{"loading":_vm.loading,"screening":this.form.fields}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }